import { render, staticRenderFns } from "./searchArea.vue?vue&type=template&id=64873688"
import script from "./searchArea.vue?vue&type=script&lang=js"
export * from "./searchArea.vue?vue&type=script&lang=js"
import style0 from "./searchArea.vue?vue&type=style&index=0&id=64873688&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports